import { Validator } from '@vista-digital/validator';
import { defaultJourneyActionButtonAppleWalletProps, journeyActionButtonAppleWalletPropsValidator } from '../subcomponents/apple-wallet/types/props';
import { defaultJourneyActionButtonGooglePayProps, journeyActionButtonGooglePayPropsValidator } from '../subcomponents/google-pay/types/props';
import { defaultJourneyActionButtonSwapSeatsProps, journeyActionButtonSwapSeatsPropsValidator } from '../subcomponents/swap-seats/types/props';
import { defaultJourneyActionButtonCustomProps, journeyActionButtonCustomPropsValidator } from './custom-props';
import { JourneyActionButtonType } from './type';
export const defaultJourneyActionButtonPropsProvider = props => {
    switch (props.type) {
        case JourneyActionButtonType.AppleWallet:
            return defaultJourneyActionButtonAppleWalletProps;
        case JourneyActionButtonType.GooglePay:
            return defaultJourneyActionButtonGooglePayProps;
        case JourneyActionButtonType.SwapSeats:
            return defaultJourneyActionButtonSwapSeatsProps;
        case JourneyActionButtonType.Custom:
            return defaultJourneyActionButtonCustomProps;
        default:
            throw new Error('Unsupported JourneyActionButtonType provided.');
    }
};
export const journeyActionButtonPropsValidator = Validator.any([
    journeyActionButtonAppleWalletPropsValidator,
    journeyActionButtonGooglePayPropsValidator,
    journeyActionButtonSwapSeatsPropsValidator,
    journeyActionButtonCustomPropsValidator
]);
